type Feature = 'influencer-discovery' | 'social-listening';

export const useFeatureFlag = (feature: Feature) => {
  switch (feature) {
    case 'influencer-discovery':
      return true;
    case 'social-listening':
      return true;
    default:
      throw new Error('Invalid feature');
  }
};
